import { render, staticRenderFns } from "./EditFanTagsModal.vue?vue&type=template&id=16963ef8&scoped=true&"
import script from "./EditFanTagsModal.vue?vue&type=script&lang=js&"
export * from "./EditFanTagsModal.vue?vue&type=script&lang=js&"
import style0 from "./EditFanTagsModal.vue?vue&type=style&index=0&id=16963ef8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16963ef8",
  null
  
)

export default component.exports